import React, { useState, useEffect, useContext } from 'react';
import { Images } from '../assets';
import { useLocation, useHistory } from 'react-router-dom';
import { getOrders } from '../api';
import moment from 'moment';
import { GoBack } from '../components/back-button';
import { MainContext } from '../components/context/context';
import { convertCurrency, getLocalStorageData } from '../common/resubale-functions';
import PaginationComponent from '../components/pagination/Pagination';
import OrderCard from '../components/order_card/index'
import mixpanel from 'mixpanel-browser';
import { bankpay_consumer_user_id } from '../common/constants';

const Orders = () => {
    const history = useHistory();
    const [orders, setAllOrders] = useState([]);

    const context = useContext(MainContext);
    const { path, setPath } = context;
    const [page, setPage] = useState(1);

    const [totalCount, setTotalCount] = useState(0);

    const handleCurrentPage = (current) => setPage(current);
    var event_sent = false;

    useEffect(() => {
        document.title = "Orders";
    })
    useEffect(() => {
        getOrderLists(page);
    }, [page]);

    const getOrderLists = async () => {
        const res = await getOrders(page);
        setAllOrders(res?.data?.data?.results);
        if (page >= 2) {
            setAllOrders([...orders, ...res?.data.data?.results]);
        }
        setTotalCount(res?.data?.data?.count);
        if (!event_sent) {
            mixpanel.track("Viewed Orders Home", {
                distinct_id: getLocalStorageData(bankpay_consumer_user_id, 'string'),
                touch_point: "consumer web",
                total_orders: res?.data.data?.results?.length,
              },
              {send_immediately: true}
            );
            event_sent = true
        }
    };

    return (
        <>
            <div className="orders-detail-page max-w-[710px] mx-auto py-5 flex flex-col lg:h-full">
                <div className="orders-detail-page-inner h-full">
                    <div className="h-full flex flex-col">
                        <div className="page-title text-[32px] font-Rany font-bold grow-0 shrink-0 flex gap-4 items-center  pb-4 lg:p-2 lg:pt-0">
                            Orders
                        </div>
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:p-2 flex-col">
                            {orders.map((item, index) => (
                                <OrderCard details={item} key={'order_' + index} />
                            ))}
                        </div>
                        <div className="shrink-0 text-center pt-6 grow-0">
                            {orders.length < totalCount &&
                                <div onClick={() => handleCurrentPage(page + 1)}
                                    className="bg-[#E9ECEF] py-1 px-3 cursor-pointer inline-flex gap-2 items-center rounded-lg hover:bg-[#6C757D] hover:text-white">
                                    See more
                                    <svg className="h-2 w-4" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.57104 9.32874L15.7638 1.86136C16.0787 1.53369 16.0787 1.00283 15.7638 0.674336C15.4489 0.346673 14.9374 0.346673 14.6225 0.674336L8.0004 7.54941L1.37835 0.675163C1.06342 0.3475 0.551909 0.3475 0.236191 0.675163C-0.0787316 1.00283 -0.0787316 1.53452 0.236191 1.86219L7.42896 9.32956C7.74062 9.65226 8.26017 9.65226 8.57104 9.32874Z" fill="currentColor" />
                                    </svg>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Orders;
